import { Chip, Flex, Text, Button } from '@shared/components';

interface FailedResultProps {
  courseId: string;
  resultId: string;
  comparisonId: string;
  qsetACode: string;
  qsetBCode: string;
  duplicatedQuestionCount: number;
}

export default function FailedResult(props: Readonly<FailedResultProps>) {
  const { courseId, resultId, comparisonId, qsetACode, qsetBCode, duplicatedQuestionCount } = props;
  return (
    <Flex
      sx={(theme) => ({
        borderRadius: theme.shape.rounded(2),
        backgroundColor: theme.palette.common.white,
        p: theme.spacing(4, 6),
        border: `1px solid ${theme.palette.grey[300]}`,
        alignItems: 'center',
      })}
    >
      <Flex sx={(theme) => ({ flexDirection: 'column', gap: theme.spacing(3) })}>
        <Text variant='body1Semibold'>
          ชุดข้อสอบ {qsetACode} กับ ชุดข้อสอบ {qsetBCode} ซ้ํากัน
        </Text>
        <Flex sx={(theme) => ({ gap: theme.spacing(1) })}>
          <Text color='textSecondary'>จำนวนข้อที่ซ้ำกัน:</Text>
          <Chip
            label={`${duplicatedQuestionCount} ข้อ`}
            size='small'
            color='error'
            sx={(theme) => ({
              minWidth: '57px',
              minHeight: '24px',
              color: theme.palette.error.dark,
              border: `1px solid ${theme.palette.error.main}`,
            })}
          />
        </Flex>
      </Flex>
      <Button
        href={`/exam-courses/${courseId}/qsets/similarity-check/results/${resultId}/${comparisonId}`}
        target='_blank'
        variant='outlined'
        color='secondary'
        sx={{ ml: 'auto' }}
      >
        View Details
      </Button>
    </Flex>
  );
}
